import { CommonModule } from '@angular/common'
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http'
import { NgModule } from '@angular/core'
import { RouterModule } from '@angular/router'
import { OAuthModule, OAuthService } from 'angular-oauth2-oidc'
import { AuthWrapperService, AuthGuard, AuthInterceptor } from './models/services/auth'
import { PasswordService } from './models/services/passwordRules'
import { UserApiService } from './models/services/users/userApi.service'

@NgModule({
  imports: [
    CommonModule,
    HttpClientModule,
    RouterModule,
    OAuthModule.forRoot()
  ],
  providers: [
    AuthWrapperService,
    OAuthService,
    PasswordService,
    UserApiService,
    AuthGuard,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    }
  ]
})
export class SecurityModule { }
